export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: [Array, Object],
      required: true,
    },
    dataAttributes: {
      type: [Array, Object],
    },
  },

  components: {
    hotAccordionToTab: () => import('~/components/Organisms/AccordionToTab/AccordionToTab.vue'),
  },
}
